import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        table: {
            maxHeight: '50vh',
        },
        tableCellHead: {
            fontWeight: 600,
        },
        tableCell: {
            padding: '5px !important',
        },
        paper: {
            width: theme.spacing(96),
        },
    }
})
